import { render, staticRenderFns } from "./ConsultantCreate.vue?vue&type=template&id=c6bc6c3a&"
import script from "./ConsultantCreate.vue?vue&type=script&lang=js&"
export * from "./ConsultantCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports